<template>
  <work-order-card v-if="visible">
    <h3 slot="card-header">申请信息</h3>
    <div slot="card-body" class="work-order-apply-info-root">
      <el-form v-if="isSeal" :label-width="labelWidth">
        <el-form-item label="公司公章：">
          {{ formatBool(sq.needCompanySeal) }}
        </el-form-item>
        <el-form-item v-if="sq.needCompanySeal" label="公章主体：">
          {{ sq.sealEntityName }}
        </el-form-item>
        <el-form-item
          label="附件："
          v-if="sq.needCompanySeal && workOrder.attachVos"
          class="no-wrap"
        >
          <template v-for="(item, index) in workOrder.attachVos">
            <span style="color: rgb(96, 98, 102)">
              <i class="el-icon-document"></i> {{ item.appendisName }}
            </span>
            <el-button
              type="text"
              @click="downloadFile(item)"
              style="margin-right: 10px"
            >
              点击下载
            </el-button>
          </template>
        </el-form-item>
        <el-form-item label="公司资质：">
          {{ formatBool(sq.needQualification) }}
        </el-form-item>
        <el-form-item v-if="sq.needQualification" label="资质主体：">
          {{ displayText(sq.qualificationEntityName) }}
        </el-form-item>
        <el-form-item v-if="sq.needQualification" label="资质名称：">
          {{ displayText(sq.qualificationType) }}
        </el-form-item>
        <el-form-item label="需要法人信息：">
          {{ formatBool(sq.needLegalPersonInfo) }}
        </el-form-item>
        <el-form-item label="公章资质外带：">
          {{ formatBool(sq.isTakenOut) }}
        </el-form-item>
        <el-form-item label="用途：">
          {{ displayText(sq.purpose) }}
        </el-form-item>
        <el-form-item label="具体使用说明：">
          <div class="multiline-text">
            {{ displayText(sq.usageDescription) }}
          </div>
        </el-form-item>
      </el-form>
      <el-form v-else-if="isAccount" :label-width="labelWidth">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开通员工姓名：">
              {{ displayText(ac.employeeName) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开通员工职位：">
              {{ displayText(ac.employeePosition) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开通员工号码：">
          {{ displayText(ac.employeePhone) }}
        </el-form-item>
        <el-form-item label="申请系统：">
          {{ applySystemNamesJoined }}
        </el-form-item>
        <el-form-item label="权限需求：">
          <template v-for="(row, index) in applySystemsList">
            <span
              style="
                background-color: #f9fafc;
                padding: 0 4px;
                border: 1px solid #eaeefb;
                border-radius: 4px;
              "
              >{{ row.systemName }}</span
            >：
            <div
              style="
                border: 1px solid #ebebeb;
                background-color: #f9fafc;
                border-radius: 3px;
                padding: 8px 12px;
                margin-top: 5px;
                margin-bottom: 12px;
                font-size: 0;
              "
            >
              <span style="font-size: 14px">{{ row.permissionDetails }}</span>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </div>
  </work-order-card>
</template>

<script>
export default {
  name: "workOrderApplyInfo",
  props: {
    workOrder: {
      type: Object,
      default: () => ({}),
    },
    labelWidth: {
      type: String,
      default: "110px",
    },
  },
  computed: {
    visible() {
      return this.isSeal || this.isAccount;
    },
    isSeal() {
      console.log("workOrder==>", this.workOrder);
      return (
        this.workOrder && this.workOrder.handlerType === "SEAL_QUALIFICATION"
      );
    },
    isAccount() {
      return (
        this.workOrder && this.workOrder.handlerType === "ACCOUNT_CREATION"
      );
    },
    sq() {
      return (this.workOrder && this.workOrder.sealQualification) || {};
    },
    ac() {
      return (this.workOrder && this.workOrder.accountCreation) || {};
    },
    applySystemsList() {
      const list = this.ac.applySystems;
      return Array.isArray(list) ? list : [];
    },
    applySystemNamesJoined() {
      const names = this.applySystemsList
        .map((row) =>
          row && row.systemName ? String(row.systemName).trim() : "",
        )
        .filter(Boolean);
      return names.length ? names.join("、") : "—";
    },
  },
  methods: {
    displayText(val) {
      if (val == null) {
        return "—";
      }
      const s = String(val).trim();
      return s === "" ? "—" : s;
    },
    formatBool(val) {
      if (val === true) {
        return "是";
      }
      if (val === false) {
        return "否";
      }
      return "—";
    },
    downloadFile(item) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", item.appendisUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          saveAs(xhr.response, item.appendisName);
        }
      };
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-apply-info-root {
  /deep/ .el-form-item {
    margin-bottom: 0px !important;
  }
}
</style>
